export const OG_META_IMAGE = `${process.env.REACT_APP_BASE_URL}/images/social-logo.png`;
